import React from "react";
import YoutubeEmbed from "./YoutubeEmbed";
import "./YoutubeEmbed.css";

function YoutubeWrap() {
  return (
    <section className="youtube-section band" id="video">
      <div className="wrap">
        <div className="youtube-inner-card">
          <p className="eyebrow">Clinical insights on video</p>
          <h2 className="h-sec">Expert Doctor Talks</h2>
          <p className="lede" style={{ marginTop: '14px' }}>
            Watch our trusted doctors share insights, guidance, and real clinical advice on pregnancy, childbirth, and newborn health.
          </p>
          <YoutubeEmbed embedId="shxqFEtApuY" />
        </div>
      </div>
    </section>
  );
}

export default YoutubeWrap;
